import DataTable from 'datatables.net-dt';
// import 'datatables.net-responsive'

export default function initTables() {
    document.querySelectorAll('.table-block:not(.calculator-table,.no-datatables)').forEach(( table_block_el ) => {
		table_block_el.querySelectorAll('table').forEach(( table_el ) => {
			let filter_el = table_block_el.querySelector('.filters');
			try{
				//disable alert message from DataTable
				DataTable.ext.errMode = 'none';

				//responsive option was causing loop on the resize event
				let isResponsive = false;
				let table = false;
				let ordering = true;

				if(table_block_el.querySelector('.table-holder')?.getAttribute('data-sorting') === 'false'){
					ordering = false;
				}

				let initTable = function () {
					let tableOptions = {
						paging: false,
						searching: true,
						ordering: ordering,
						// sScrollX: "100%",
						initComplete: function () {
							this.api().columns().every(function (d) {
								if(filter_el === null) return;
								let column = this;
								var theadname = table_el.tHead.rows[0].cells[d].textContent;
								//check if the element exists in the dom .filter and data-filter=theadname
								let filterItem = filter_el.querySelector(`.filter[data-filter="${theadname}"]`);
								if (filterItem) {
									let select = document.createElement('select');
									let selectOptions = [];
									select.classList.add('form-select');
									select.add(new Option(theadname));
									select.addEventListener('change', function (){
										if(select.value === theadname){
											column.search('').draw();
											return;
										}
										column.search(select.value, {exact: false}).draw();
									});

									column
										.data()
										.unique()
										.sort()
										.each(function (d, j) {
											if(d === null || d === '') return;
											d.split(/[\n,]+/).forEach(function (d) {
												d = d.trim();
												if(!selectOptions.includes(d)){
													selectOptions.push(d);
													select.add(new Option(d));
												}
											})
										}
									);

									filterItem.append(select);
								}
							});
						}

					}
					if(isResponsive){
						/*
						tableOptions = {
							...tableOptions,
							autoWidth: false,
							responsive: {
								details: {
									display: DataTable.Responsive.display.childRowImmediate,
									type: 'none',
									renderer: ( api, rowIdx, columns ) => {
										var isMobileView = window.matchMedia("(max-width: 1140px)").matches;
										if(isMobileView){
											var data = $.map( columns, function ( col, i ) {
												if(col.columnIndex == 0){
													return `<h6 class='column-name'>${col.data}</h6>`;
												};
												return `<div class='column-details'><strong>${col.title}</strong>:  ${col.data}</div>`;
												return '<tr data-dt-row="'+col.rowIndex+'" data-dt-column="'+col.columnIndex+'">'+
														'<td data-title="'+col.title+'">'+col.title+':  '+col.data+'</td>'+
													'</tr>';
											} ).join('');
											return data ?
												$('<div class="table-responsive-inner"/>').append( data ) :
												false;
										}else{
											return DataTable.Responsive.renderer.tableAll();
										}
									}
								},
							},
						}
							*/
					}

					table = new DataTable(table_el, tableOptions);
				}

				initTable();
				// if(isResponsive){
				// 	window.addEventListener('resize', () => {
				// 		if (table) {
				// 			console.log("destoryi", table);
				// 			// table.destroy();
				// 			table.columns.adjust().draw();
				// 		}
				// 		// initTable();
				// 	});
				// }
			}catch(e){
				console.log("datatable error", e);
			}

			//go through all links in the table and convert them to a tooltip
			table_block_el.querySelectorAll('a').forEach(( link_el ) => {
				if(link_el.href.indexOf('mailto:') === 0 || link_el.href.indexOf('tel:') === 0){
					link_el.setAttribute('data-bs-toggle', 'tooltip');
					link_el.setAttribute('data-bs-placement', 'top');
					link_el.setAttribute('data-bs-title', link_el.textContent);
					link_el.classList.add('styled-table-link');
					if(link_el.href.indexOf('mailto:') === 0){
						link_el.innerHTML = '<i class="icon-envelope"></i> <span>EMAIL</span>';
					}
					if(link_el.href.indexOf('tel:') === 0){
						link_el.innerHTML = '<i class="icon-phone"></i> <span>PHONE</span>';
					}
				}
			});
		});
	});


	//inline nav: list block
	document.querySelectorAll('.inline-nav-list').forEach(( block_el ) => {
		let datasource = block_el.querySelector('.data-source table');
		let items = [];
		let header_cols = [];
		if(datasource){
			let item_count = 0;
			datasource.querySelectorAll('th').forEach(( th_el ) => {
				header_cols.push(th_el.textContent);
			});
			datasource.querySelectorAll('tr').forEach(( row_el ) => {
				item_count++;
				let columns = [];
				let columns_el = row_el.querySelectorAll('td');
				if(columns_el.length < 2) return;
				let count = 0;
				//loop through columns and add to item
				columns_el.forEach(( column_el ) => {
					count++;
					if(count >= 2){
						columns[`column_${count}`] = column_el.textContent;
					}
				});

				let item = {
					'id': item_count,
					'title': row_el.querySelector('td:first-child a > :not(.visually-hidden)')?.textContent,
					'link': row_el.querySelector('td:first-child a')?.href,
					...columns
				};
				items.push(item);
			});
		}

		if(items.length === 0) return;

		const clickInlineNavItem = (e, item_el, block_el) => {
			e.preventDefault();
			let id = item_el.getAttribute('data-id');
			block_el.querySelectorAll('.inline-nav-list-items a').forEach(( item ) => {
				item.classList.remove('active');
			});
			item_el.classList.add('active');
			block_el.querySelector('.list-contents').innerHTML = '';
			items.forEach(( item ) => {
				if(item.id == id){
					let columns_html = '';
					columns_html += `<div class="column-name"><a target="_blank" href="${item.link}">${item.title}</a></div>`;
					Object.keys(item).forEach(( key ) => {
						if(key === 'id' || key === 'title' || key === 'link') return;
						columns_html += `<div class="column"><div class="label">${header_cols[key.replace('column_', '')-1]}</div><div class="value">${item[key]}</div></div>`;
					});
					block_el.querySelector('.list-contents').innerHTML = columns_html;
				}
			});
		}

		block_el.querySelector('.inline-nav-list-items').innerHTML = '';
		items.forEach(( item ) => {
			let item_el = document.createElement('li');
			item_el.innerHTML = `<a href="#${item.id}" data-id="${item.id}">${item.title}</a>`;
			block_el.querySelector('.inline-nav-list-items').append(item_el);
		});

		block_el.querySelectorAll('.inline-nav-list-items a').forEach(( item_el ) => {
			item_el.addEventListener('click', (event) => {
				clickInlineNavItem(event, item_el, block_el);
			});
		});
		block_el.querySelector('.inline-nav-list-items a:first-child').click();

		block_el.querySelector('.search-input').addEventListener('input', (event) => {
			let value = event.target.value;
			block_el.querySelector('.inline-nav-list-items').innerHTML = '';
			items.forEach(( item ) => {
				if(item.title.toLowerCase().indexOf(value.toLowerCase()) > -1){
					let item_el = document.createElement('li');
					item_el.innerHTML = `<a href="#${item.id}" data-id="${item.id}">${item.title}</a>`;
					block_el.querySelector('.inline-nav-list-items').append(item_el);
					let anchor = block_el.querySelector(`a[data-id="${item.id}"]`);
					anchor.addEventListener('click', (event) => {
						clickInlineNavItem(event, anchor, block_el);
					});
				}
			});
		});
	});

	//inline nav: tabs block
	document.querySelectorAll('.inline-nav-tabs').forEach(( block_el ) => {
		block_el.querySelectorAll('.list-contents a').forEach(( item_el ) => {
			item_el.addEventListener('click', (event) => {
				event.preventDefault();
				block_el.querySelectorAll('.list-contents li').forEach(( sibling_el ) => {
					sibling_el.classList.remove('active');
				});
				item_el.parentElement.classList.add('active');

				let id = parseInt(item_el.getAttribute('data-id'));
				let count = 0;
				block_el.querySelectorAll('.list-holder .wp-block-column').forEach(( column_el ) => {
					count++;
					column_el.style.display = 'none';
					if(count === id){
						column_el.style.display = 'block';
					}
				});
				block_el.querySelector('.list-holder').scrollTo(0, 0);
			});
		});
		block_el.querySelector('.list-contents li:first-child a')?.click();
	});
}
